import React, { Component } from 'react';
import { Button as AntdBtn, Icon as AntIcn, Input, Modal, Collapse, Tabs, Select, Form } from 'antd';
const confirmModal = Modal.confirm;
const Panel = Collapse.Panel;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

class ScheduleAllDialog extends Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            data: [],
            siteName: "",
            selectedDate: "",
            selectedOperid: "ALL",
            startSOrderOptions: [],
            endSOrderOptions: [],
            selectedStartSOrder: -1,
            selectedEndSorder: -1
        }
    }

    componentWillReceiveProps(theNextProps) {
        if (theNextProps != null && theNextProps.data != null) {
            if (this.state.selectedDate == null || this.state.selectedDate.length == 0 || this.state.siteName == null || this.state.siteName.length == 0 ||
                this.state.data == null || this.state.data.length == 0 || this.state.selectedDate != theNextProps.selectedDate.replace("-20", "-") ||
                this.state.siteName != theNextProps.userName.toUpperCase() || this.state.selectedOperid != theNextProps.selectedOperid ||
                JSON.stringify(this.state.data) != JSON.stringify(theNextProps.data)) {
                this.setState({ data: theNextProps.data });
                this.setState({ selectedDate: theNextProps.selectedDate.replace("-20", "-") });
                this.setState({ siteName: theNextProps.userName.toUpperCase() });
                this.setState({ selectedOperid: theNextProps.selectedOperid });
                var aTempStartSOrderOptions = [];
                if (theNextProps.data != null && theNextProps.data.length != 0) {
                    aTempStartSOrderOptions = this.initStartSOrderOptions(theNextProps.data[theNextProps.data.length - 1].sorder, theNextProps.data);
                }
                var aTempSelectedStartSOrder = -1;
                if (this.state.selectedStartSOrder < 0) {
                    if (aTempStartSOrderOptions != null && aTempStartSOrderOptions.length != 0) {
                        for (var i = 0; i < aTempStartSOrderOptions.length; i++) {
                            if (!aTempStartSOrderOptions[i].props.disabled) {
                                aTempSelectedStartSOrder = aTempStartSOrderOptions[i].props.value;
                                break;
                            }
                        }
                    }
                }
                var aTempSelectedEndSOrder = -1;
                var aTempEndSOrderOptions = [];
                if (aTempSelectedStartSOrder >= 0) {
                    var aTempEndSOrderOptions = this.initEndSOrderOptions(aTempSelectedStartSOrder, theNextProps.data);
                    if (this.state.selectedEndSorder < 0) {
                        if (aTempEndSOrderOptions != null && aTempEndSOrderOptions.length != 0) {
                            for (var i = aTempEndSOrderOptions.length - 1; i >= 0; i++) {
                                if (!aTempEndSOrderOptions[i].props.disabled) {
                                    aTempSelectedEndSOrder = aTempEndSOrderOptions[i].props.value;
                                    break;
                                }
                            }
                        }
                    }
                }
                this.setState({ startSOrderOptions: aTempStartSOrderOptions });
                this.setState({ endSOrderOptions: aTempEndSOrderOptions });
                this.setState({ selectedStartSOrder: aTempSelectedStartSOrder });
                this.setState({ selectedEndSorder: aTempSelectedEndSOrder });
            }
        }
    }

    initStartEndSorderOptions(theData, theDate, theUserName, theSelectedOperid) {
        this.setState({ data: theData });
        this.setState({ selectedDate: theDate.replace("-20", "-") });
        this.setState({ siteName: theUserName.toUpperCase() });
        this.setState({ selectedOperid: theSelectedOperid });
        var aTempStartSOrderOptions = [];
        if (theData != null && theData.length != 0) {
            aTempStartSOrderOptions = this.initStartSOrderOptions(theData[theData.length - 1].sorder, theData);
        }
        var aTempSelectedStartSOrder = -1;
        if (this.state.selectedStartSOrder < 0) {
            if (aTempStartSOrderOptions != null && aTempStartSOrderOptions.length != 0) {
                for (var i = 0; i < aTempStartSOrderOptions.length; i++) {
                    if (!aTempStartSOrderOptions[i].props.disabled) {
                        aTempSelectedStartSOrder = aTempStartSOrderOptions[i].props.value;
                        break;
                    }
                }
            }
        }
        var aTempSelectedEndSOrder = -1;
        var aTempEndSOrderOptions = [];
        if (aTempSelectedStartSOrder >= 0) {
            var aTempEndSOrderOptions = this.initEndSOrderOptions(aTempSelectedStartSOrder, theData);
            if (this.state.selectedEndSorder < 0) {
                if (aTempEndSOrderOptions != null && aTempEndSOrderOptions.length != 0) {
                    for (var i = aTempEndSOrderOptions.length - 1; i >= 0; i++) {
                        if (!aTempEndSOrderOptions[i].props.disabled) {
                            aTempSelectedEndSOrder = aTempEndSOrderOptions[i].props.value;
                            break;
                        }
                    }
                }
            }
        }
        this.setState({ startSOrderOptions: aTempStartSOrderOptions });
        this.setState({ endSOrderOptions: aTempEndSOrderOptions });
        this.setState({ selectedStartSOrder: aTempSelectedStartSOrder });
        this.setState({ selectedEndSorder: aTempSelectedEndSOrder });
    }

    initStartSOrderOptions(theEndSorder, theData) {
        var aTemp = [];
        if (theData != null && theData.length != 0) {
            for (var i = 0; i < theData.length; i++) {
                // aTemp.push(<Option key={theData[i].sorder} value={theData[i].sorder} disabled={i == theData.length - 1 ? true : false}>{theData[i].sorder}</Option>);
                aTemp.push(<Option key={theData[i].sorder} value={theData[i].sorder} disabled={theData[i].sorder >= theEndSorder ? true : false}>{theData[i].sorder}</Option>);
            }
        }
        return aTemp;
    }

    initEndSOrderOptions(theStartSorder, theData) {
        var aTemp = [];
        if (theData != null && theData.length != 0) {
            for (var i = 0; i < theData.length; i++) {
                aTemp.push(<Option key={theData[i].sorder} value={theData[i].sorder} disabled={theData[i].sorder <= theStartSorder ? true : false} >{theData[i].sorder}</Option>);
            }
        }
        return aTemp;
    }

    componentWillUnmount() {
        console.log("ScheduleAllDialog componentWillUnmount");
    }

    openScheduleAllDialog() {
        this.setState({
            visible: true
        });
        if (this.state.selectedDate == null || this.state.selectedDate.length == 0 || this.state.siteName == null || this.state.siteName.length == 0 ||
            this.state.data == null || this.state.data.length == 0 || this.state.selectedDate != this.props.selectedDate.replace("-20", "-") ||
            this.state.siteName != this.props.userName.toUpperCase() || this.state.selectedOperid != this.props.selectedOperid ||
            JSON.stringify(this.state.data) != JSON.stringify(this.props.data)) {
            this.initStartEndSorderOptions(this.props.data, this.props.selectedDate, this.props.userName, this.props.selectedOperid);
        }
    }

    closeScheduleAllDialog() {
        this.setState({ visible: false });
    }

    handleChangeStartSOrder(value) {
        this.setState({ selectedStartSOrder: value });
        var aTempEndSOrderOptions = this.initEndSOrderOptions(value, this.props.data);
        this.setState({ endSOrderOptions: aTempEndSOrderOptions });
    }

    handleChangeEndSOrder(value) {
        this.setState({ selectedEndSorder: value });
        var aTempStartSOrderOptions = this.initStartSOrderOptions(value, this.props.data);
        this.setState({ startSOrderOptions: aTempStartSOrderOptions });
    }

    onOkClick() {
        if (this.state.selectedStartSOrder >= 0 && this.state.selectedEndSorder >= 0 && this.state.selectedStartSOrder < this.state.selectedEndSorder) {
            this.props.handleBatchRange(this.state.selectedStartSOrder, this.state.selectedEndSorder);
            this.setState({
                visible: false
            });
        }
    }

    render() {
        return (
            <Modal
                title="Select SOrders"
                style={{ top: 88, }}
                width='366px'
                visible={this.state.visible}
                okText="Ok"
                onOk={() => this.onOkClick()}
                onCancel={() => this.closeScheduleAllDialog()}
            >
                <div>
                    <Form.Item {...formItemLayout} label="Start SOrder">
                        <Select value={this.state.selectedStartSOrder} style={{ width: 120 }} onChange={this.handleChangeStartSOrder.bind(this)} >
                            {this.state.startSOrderOptions}
                        </Select>
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="End SOrder">
                        <Select value={this.state.selectedEndSorder} style={{ width: 120 }} onChange={this.handleChangeEndSOrder.bind(this)} >
                            {this.state.endSOrderOptions}
                        </Select>
                    </Form.Item>
                </div>
            </Modal>
        );
    }
}

export default ScheduleAllDialog;
